<script>
import { mapGetters } from 'vuex';
import { getBlockedFeatureKeys } from 'dashboard/constants/accessControl.js';
import ConversationHeader from './ConversationHeader.vue';
import DashboardAppFrame from '../DashboardApp/Frame.vue';
import EmptyState from './EmptyState/EmptyState.vue';
import MessagesView from './MessagesView.vue';
import SimuladorModal from './SimuladorClt/SimuladorModal.vue';

export default {
  components: {
    ConversationHeader,
    DashboardAppFrame,
    EmptyState,
    MessagesView,
    SimuladorModal,
  },
  props: {
    inboxId: {
      type: [Number, String],
      default: '',
      required: false,
    },
    isInboxView: {
      type: Boolean,
      default: false,
    },
    isContactPanelOpen: {
      type: Boolean,
      default: true,
    },
    isOnExpandedLayout: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return { activeIndex: 0, showSimulador: false };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      dashboardApps: 'dashboardApps/getRecords',
      currentUser: 'getCurrentUser',
    }),
    // v105: botao Simulador controlavel pelo Controle de Acesso (key
    // 'Simulador' no ui_blocklist). id 1 nunca e bloqueado.
    canSeeSimulador() {
      return !getBlockedFeatureKeys(this.currentUser).includes('Simulador');
    },
    dashboardAppTabs() {
      return [
        {
          key: 'messages',
          index: 0,
          name: this.$t('CONVERSATION.DASHBOARD_APP_TAB_MESSAGES'),
        },
        ...this.dashboardApps.map((dashboardApp, index) => ({
          key: `dashboard-${dashboardApp.id}`,
          index: index + 1,
          name: dashboardApp.title,
        })),
      ];
    },
    showContactPanel() {
      return this.isContactPanelOpen && this.currentChat.id;
    },
  },
  watch: {
    'currentChat.inbox_id': {
      immediate: true,
      handler(inboxId) {
        if (inboxId) {
          this.$store.dispatch('inboxAssignableAgents/fetch', [inboxId]);
        }
      },
    },
    'currentChat.id'() {
      this.fetchLabels();
      this.activeIndex = 0;
    },
  },
  mounted() {
    this.fetchLabels();
    this.$store.dispatch('dashboardApps/get');
  },
  methods: {
    fetchLabels() {
      if (!this.currentChat.id) {
        return;
      }
      this.$store.dispatch('conversationLabels/get', this.currentChat.id);
    },
    onDashboardAppTabChange(index) {
      this.activeIndex = index;
    },
  },
};
</script>

<template>
  <div
    class="conversation-details-wrap flex flex-col min-w-0 w-full bg-n-surface-1 relative"
    :class="{
      'border-l rtl:border-l-0 rtl:border-r border-n-weak': !isOnExpandedLayout,
    }"
  >
    <ConversationHeader
      v-if="currentChat.id"
      :chat="currentChat"
      :show-back-button="isOnExpandedLayout && !isInboxView"
      :class="{
        'border-b border-b-n-weak !pt-2': !dashboardApps.length,
      }"
    />
    <!-- v92: barra de abas + botao Simulador. v93: a aba "Mensagens" aparece
         SEMPRE (mesmo sem dashboard apps) e o Simulador fica DO LADO dela. -->
    <div
      v-if="currentChat.id"
      class="flex items-center border-b border-b-n-weak"
    >
      <woot-tabs
        :index="activeIndex"
        class="h-10 !border-b-0"
        @change="onDashboardAppTabChange"
      >
        <woot-tabs-item
          v-for="tab in dashboardAppTabs"
          :key="tab.key"
          :index="tab.index"
          :name="tab.name"
          :show-badge="false"
          is-compact
        />
      </woot-tabs>
      <button
        v-if="canSeeSimulador"
        type="button"
        class="flex gap-1.5 items-center px-3 py-1 mx-2 my-1 text-xs font-bold text-white rounded-lg bg-n-teal-9 hover:opacity-90 whitespace-nowrap"
        @click="showSimulador = true"
      >
        <span class="i-lucide-calculator size-3.5" />
        Simulador
      </button>
      <span class="flex-1" />
    </div>
    <div v-show="!activeIndex" class="flex h-full min-h-0 m-0">
      <MessagesView
        v-if="currentChat.id"
        :inbox-id="inboxId"
        :is-inbox-view="isInboxView"
      />
      <EmptyState
        v-if="!currentChat.id && !isInboxView"
        :is-on-expanded-layout="isOnExpandedLayout"
      />
      <slot />
    </div>
    <DashboardAppFrame
      v-for="(dashboardApp, index) in dashboardApps"
      v-show="activeIndex - 1 === index"
      :key="currentChat.id + '-' + dashboardApp.id"
      :is-visible="activeIndex - 1 === index"
      :config="dashboardApps[index].content"
      :position="index"
      :current-chat="currentChat"
    />
    <!-- v92: Simulador CLT (digitador dentro do Chatwoot) -->
    <!-- v105: tambem respeita o Controle de Acesso (key 'Simulador') -->
    <SimuladorModal
      v-if="canSeeSimulador && showSimulador && currentChat.id"
      :current-chat="currentChat"
      @close="showSimulador = false"
    />
  </div>
</template>
